import * as Sentry from '@sentry/vue'
import type { Router } from 'vue-router'
import { INSIGHTS_SENTRY_DSN, ENV } from '@/consts'

export const initializeSentry = (app: any, router: Router) => {
  if (ENV === 'development') return

  Sentry.init({
    app,
    dsn: INSIGHTS_SENTRY_DSN(),
    environment: ENV,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: ENV === 'production' ? 1.0 : 0.3,
    tracePropagationTargets: [
      /^https:\/\/api\.attensi\.com\/api/,
      /^https:\/\/auth\.attensi\.com\/api/,
      /^https:\/\/hasura\.attensi\.com\/v1/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
